import {format, formatISO, parseISO} from 'date-fns'
import { da } from 'date-fns/locale'

export default function formatInLocale(date:Date,formatString:string){
  return format(date, formatString, { locale: da })
}

export function formatDateToUrl(date:Date) {
  return encodeURIComponent(formatISO(date))
}

// returns null if date string could not be parsed to a correct date
export function parseISODate(dateString:string) : Date | null {
  const p = parseISO(dateString)
  if(!isValidDate(p)){
    return null
  }
  return p
}

function isValidDate(d:unknown) {
  // @ts-expect-error this is how we check for a valid date..
  return d instanceof Date && !isNaN(d);
}

